import React, { useEffect, useState } from 'react'
import styles from './ipTv.jcss'
import translate from '../../core/translate'
import Content from 'blocks.app/content/content'
import { Channels } from './__channels/Channels'
import { cn } from 'ethcss'
import { Categories } from './__categories/Categories'
import Uploader from 'blocks.app/uploader'
import grid from 'blocks.simple/grid/grid.jcss'
import { Groups } from './__groups/Groups'
import Button from '../../blocks.simple/button/button'
import { api } from '../../core/api/ConnectionManager'
import { toast } from 'react-toastify'

export const IpTv = () => {
    const tabs = ['channels', 'channelGroups', 'categories', 'upload']
    const [activeTab, setActiveTab] = useState('channels')

    const onUploadSuccess = () => {
        toast.success(translate('downloadComplete'), {
            hideProgressBar: true,
            position: 'bottom-left',
        })
    }

    const renderIptvDownloadCsv = () => {
        const getFile = () => {
            api.send('iptvGetCsv', {}).then((res) => {
                console.log(res)
            })
        }

        return (
            <div className={cn(styles.section, grid.mt_miniPlus, grid.mb_miniPlus)}>
                <div className={styles.hint}>{translate('ipTvFileHint')}</div>
                <Button className={styles.uploadBtn} mod={'withShadow'} onClick={getFile}>
                    {translate('downloadIptvFile')}
                </Button>
            </div>
        )
    }

    const renderTab = (activeTab: string) => {
        switch (activeTab) {
            case 'channels':
                return <Channels />
            case 'channelGroups':
                return <Groups />
            case 'categories':
                return <Categories />
            case 'upload':
                return (
                    <div className={cn(grid.w100, grid.flex, grid.center)}>
                        <Uploader
                            uploadMethod={'uploadChannelsAndCategoryCsvFile'}
                            isModal={false}
                            customBlock={renderIptvDownloadCsv}
                            onResponse={onUploadSuccess}
                        />
                    </div>
                )
            default:
                return null
        }
    }

    function downloadAsFile(url: any) {
        let a = document.createElement('a')
        a.href = url
        a.click()
    }

    useEffect(() => {
        const listenersId: string[] = []

        api.addObserver(
            'iptvDownloadFileReady',
            (url: any) => {
                downloadAsFile(url)
            },
            listenersId
        )

        return () => {
            listenersId.forEach((id) => api.removeObserver(id))
        }
    }, [])

    return (
        <Content title={translate('ipTv')} wrapperClassName={styles.ipTv}>
            <div className={styles.tabsWrapper}>
                {tabs.map((tab) => (
                    <div
                        className={cn(styles.tabBtn, tab === activeTab ? styles.tabActive : '')}
                        onClick={() => setActiveTab(tab)}
                    >
                        {translate(tab)}
                    </div>
                ))}
            </div>
            {renderTab(activeTab)}
        </Content>
    )
}
